import React from 'react';
import { useNavigate } from 'react-router-dom';

import * as kratos from '@ory/kratos-client';


import { ExternalUrl } from './common';

import {
  kratosApi,
  BodyValues,
  bodyValueExtractor
} from './kratos/common';

import { useInitFlow } from './kratos/useInitFlow';
import Flow from './kratos/Flow';


/*
React Component providing an (Account) Recovery UI.
  ... WIP: pending required mail server config ...
*/
export default function Recovery(props: RecoveryProps) {
  const navigate = useNavigate();
  const flowType = 'recovery';

  const {
    flowId, initFlowQuery, initFlowStatusElement
  } = useInitFlow(flowType, initFlow);

  if (flowId === '') {
    return initFlowStatusElement;
  }

  return <Flow
    flowId={flowId}
    flowType={flowType}
    flowGetter={getFlow}
    flowSubmitter={submitFlow(flowId)}
    afterSuccessfulSubmit={afterSubmit(props.returnTo, navigate)} />;
}


interface RecoveryProps
{
  returnTo?: ExternalUrl;
}


const initFlow = () => async () => await
  kratosApi.createBrowserRecoveryFlow();


const getFlow = (flowId: string) => async () => await
  kratosApi.getRecoveryFlow({ id: flowId });


const submitFlow = (flowId: string) => async (values: BodyValues) =>
{
  console.log('Recovery param values:');
  console.log(values);
  const v = bodyValueExtractor(values);

  // Currently, we use the link method because the admin UI sends out via
  // the link method as well.
  //
  // Our old, possibly incorrect guess on keys to use for the code method
  // were email: v('code-email') and method: v('code-method').
  //
  // TODO(security): Can we use the best practice method (code) here?
  const body: kratos.UpdateRecoveryFlowBody = {
    email: v('link-email'),
    method: v('link-method-link'),
    csrf_token: v('default-csrf_token')
  };

  return await kratosApi.updateRecoveryFlow({
    flow: flowId,
    updateRecoveryFlowBody: body
  });
};


function afterSubmit(
  returnTo: ExternalUrl | undefined,
  navigate: ReturnType<typeof useNavigate>)
{
  return () => {
    if (returnTo && window?.location) {
      window.location.href = returnTo;
    }
    else {
      return navigate('/');
    }
  };
}
